'use client';

import LogoutButton from '@/components/logout-button';
import { TabNavigation } from '@/components/tab-navigation';
import { Card } from '@/components/ui/card';
import { useIsMobile } from '@/hooks/use-mobile';
import { logout } from '@/lib/auth';
import { ChevronRight } from 'lucide-react';
import Link from 'next/link';
import { profileTabs } from '../utils/constants';
export function OtherSection({
  onClose
}: {
  onClose?: () => void;
}) {
  const isMobile = useIsMobile();
  return <div className="relative flex w-full flex-col" data-sentry-component="OtherSection" data-sentry-source-file="other-section.tsx">
      {isMobile && <TabNavigation tabs={profileTabs} activeTab="Others" className="sticky top-20 z-10 md:static" />}
      <div className="flex w-full flex-col items-center gap-2 px-5 py-3 pb-24">
        <Card className="w-full max-w-md pb-0 pt-6" data-sentry-element="Card" data-sentry-source-file="other-section.tsx">
          <div>
            <div className="h-[50px] w-full border-b px-6">
              <h3 className="text-sm font-normal text-muted-foreground">Version</h3>
              <p className="text-sm">v0.1.0</p>
            </div>

            <div className="h-[72px] px-6 pt-4">
              <h3 className="text-sm font-normal text-muted-foreground">Contact information</h3>
              <a href="mailto:support@eltglobal.in" className="text-sm text-blue-600 hover:underline">
                support@eltglobal.in
              </a>
            </div>

            <div className="h-[72px] border-t px-6 pt-4">
              <h3 className="text-sm font-normal text-muted-foreground">Website</h3>
              <a href="https://www.eltglobal.in" target="_blank" rel="noopener noreferrer" className="text-sm text-blue-600 hover:underline">
                www.eltglobal.in
              </a>
            </div>

            <Link href="/privacy-policy" onClick={onClose} className="flex h-[72px] items-center justify-between rounded-sm border-t px-6 text-sm hover:bg-muted" data-sentry-element="Link" data-sentry-source-file="other-section.tsx">
              Privacy policy
              <ChevronRight className="size-4 text-muted-foreground" data-sentry-element="ChevronRight" data-sentry-source-file="other-section.tsx" />
            </Link>

            <Link href="/terms-and-conditions" onClick={onClose} className="flex h-[72px] items-center justify-between rounded-sm border-t px-6 text-sm hover:bg-muted" data-sentry-element="Link" data-sentry-source-file="other-section.tsx">
              Terms and Conditions
              <ChevronRight className="size-4 text-muted-foreground" data-sentry-element="ChevronRight" data-sentry-source-file="other-section.tsx" />
            </Link>
            <div className="flex h-[72px] w-full items-center justify-start rounded-none border-t  px-6 hover:bg-muted">
              <LogoutButton serverLogout={logout} data-sentry-element="LogoutButton" data-sentry-source-file="other-section.tsx" />
            </div>
          </div>
        </Card>
      </div>
    </div>;
}